var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"size":"small"},on:{"click":_vm.preview}},[_vm._v("操作指南")])}
var staticRenderFns = []

export { render, staticRenderFns }